// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__XRKO3","label":"SetPasswdForm_label__2gzqa"};